import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { CommonModule } from '../common/common.module';
import { DeckListComponent } from './deck-list/deck-list.component';
import { DecksService } from './decks.service';
import { DeckRoutingModule } from './deck-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { CardsModule } from '../cards/cards.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { ChartsModule } from '../common/charts/charts.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DeckViewComponent } from './deck-view/deck-view.component';
import { MatRippleModule } from '@angular/material/core';
import { DeckSummaryComponent } from './deck-summary/deck-summary.component';
import { FormsModule } from '@angular/forms';
import { GtagModule } from 'angular-gtag';
import { PrettyDeckListComponent } from './pretty-deck-list/pretty-deck-list.component';
import { PublicDeckViewComponent } from './public-deck-view/public-deck-view.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { PublicDecksComponent } from './public-decks/public-decks.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
    declarations: [DeckListComponent, DeckViewComponent, DeckSummaryComponent, PrettyDeckListComponent, PublicDeckViewComponent, PublicDecksComponent],
    exports: [
        DeckListComponent,
        PrettyDeckListComponent,
        PublicDeckViewComponent
    ],
    imports: [
        CommonModule,
        NgCommonModule,
        DeckRoutingModule,
        MatListModule,
        CardsModule,
        MatGridListModule,
        MatMenuModule,
        MatDialogModule,
        MatToolbarModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatSelectModule,
        ChartsModule,
        DragDropModule,
        MatRippleModule,
        FormsModule,
        GtagModule,
        ClipboardModule,
        MatProgressBarModule
    ],
    providers: [
        DecksService
    ]
})
export class DecksModule {}
